import { semanticColours } from "styles/generated/tokens";
import { mq } from "styles/mq";

// NOTE: Try not to use the primitive colours unless necessary, use the semantic colours instead
const primitiveColours = {
  // https://www.figma.com/design/bH5c5Hh9lYRJQs2ytLlv2o/Stotles-DS---Design-Tokens-v1.0?node-id=3-3275&t=SawDKqs3pcKStcTQ-4

  // Basics

  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextWhite | sysTextWhite}, {@link lightTheme.colors.sysBackgroundDefault | sysBackgroundDefault}, {@link lightTheme.colors.sysBorderInverse | sysBorderInverse}
   */
  white: "#FFFFFF",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextBlack | sysTextBlack}
   */
  black: "#000000",

  // Blues

  /**
   * @deprecated Prefer using semantic colours instead
   */
  blue25: "#F7FAFF",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysPrimarySubtle | sysPrimarySubtle}, {@link lightTheme.colors.sysInfoSubtle | sysInfoSubtle}
   */
  blue50: "#EDF3FF",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysPrimarySubtleAlt | sysPrimarySubtleAlt}, {@link lightTheme.colors.sysInfoSubtleAlt}, {@link lightTheme.colors.sysSignalKeyword | sysSignalKeyword}
   */
  blue100: "#CADBFE",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBrandBlueComplimentary | sysBrandBlueComplimentary}
   */
  blue200: "#9DBCFB",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  blue300: "#84AAFB",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBrandBlueDefault | sysBrandBlueDefault}
   */
  blue400: "#4F86FA",
  /**
   * @deprecated Prefer using semantic colours instead.
   *
   * Used by {@link lightTheme.colors.sysPrimaryDefault | sysPrimaryDefault}, {@link lightTheme.colors.sysInfoDefault | sysInfoDefault}
   */
  blue500: "#2569F9",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysPrimaryHover | sysPrimaryHover}, {@link lightTheme.colors.sysInfoHover | sysInfoHover}
   */
  blue600: "#074FE9",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysPrimaryPressed | sysPrimaryPressed}, {@link lightTheme.colors.sysInfoPressed | sysInfoPressed}
   */
  blue700: "#0644C6",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  blue800: "#04369F",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysFocusBr | sysFocusBr}
   */
  blue900: "#032772",

  // Greys

  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBackgroundAlternative | sysBackgroundAlternative}
   */
  grey10: "#F7F7F8",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBackgroundInactive | sysBackgroundInactive}
   */
  grey25: "#EEEFF1",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBorderDecorative | sysBorderDecorative}, {@link lightTheme.colors.sysSignalDefault | sysSignalDefault}
   */
  grey50: "#E6E7EA",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  grey100: "#D5D8DD",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  grey200: "#B3B8C1",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextInactive | sysTextInactive}
   */
  grey300: "#9299A6",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextPlaceholder | sysTextPlaceholder}, {@link lightTheme.colors.sysBorderFunctional | sysBorderFunctional}
   */
  grey400: "#707A8B",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextSecondary | sysTextSecondary}
   */
  grey500: "#4F5A6F",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBackgroundInverse | sysBackgroundInverse}
   */
  grey600: "#2D3B54",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysTextDefault | sysTextDefault}
   */
  grey700: "#263247",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  grey800: "#1F2839",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBackgroundOverlay | sysBackgroundOverlay}
   */
  grey900: "#171F2C",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  grey1000: "#10151E",

  // Reds

  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysDestructiveSubtle | sysDestructiveSubtle}
   */
  red50: "#FFEEF0",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * An unlabelled step between red50 and red100, moved here from
   * lib/themes/colors.ts. No semantic token uses it; whether the ramp should
   * keep a step here is an open question for a designer.
   */
  red75: "#FFE7E9",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSignalCompetitor | sysSignalCompetitor}, {@link lightTheme.colors.sysDestructiveSubtleAlt | sysDestructiveSubtleAlt}
   */
  red100: "#FECDD1",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  red200: "#FDABB3",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  red300: "#FB8994",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysStatusNegative | sysStatusNegative}, {@link lightTheme.colors.sysBrandRedDefault | sysBrandRedDefault}
   */
  red400: "#FA5766",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysDestructiveDefault | sysDestructiveDefault}
   */
  red500: "#E9071C",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysDestructiveHover | sysDestructiveHover}
   */
  red600: "#D10519",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysDestructivePressed | sysDestructivePressed}, {@link lightTheme.colors.sysBrandRedComplimentary | sysBrandRedComplimentary}
   */
  red700: "#BF1642",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  red800: "#A80514",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  red900: "#81040F",

  // Greens

  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSuccessSubtle | sysSuccessSubtle}
   */
  green50: "#E5F5EB",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSuccessSubtleAlt | sysSuccessSubtleAlt}
   */
  green100: "#D5EEDD",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  green200: "#B3E1C2",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  green300: "#91D3A7",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  green400: "#6FC68B",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysStatusPositive | sysStatusPositive}
   */
  green500: "#4DB870",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSuccessDefault | sysSuccessDefault}
   */
  green600: "#2BAB55",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSuccessHover | sysSuccessHover}
   */
  green700: "#249047",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSuccessPressed | sysSuccessPressed}
   */
  green800: "#1D743A",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  green900: "#0F3E1F",

  // Yellows

  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysWarningSubtle | sysWarningSubtle}
   */
  yellow50: "#FFFBF0",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysWarningSubtleAlt | sysWarningSubtleAlt}
   */
  yellow100: "#FFF3D3",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysSignalPartner | sysSignalPartner}
   */
  yellow200: "#FFECB6",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  yellow300: "#FFE498",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBrandYellowDefault | sysBrandYellowDefault}
   */
  yellow400: "#FFD86C",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysStatusInProgress | sysStatusInProgress}, {@link lightTheme.colors.sysBrandYellowComplimentary | sysBrandYellowComplimentary}
   */
  yellow500: "#FFC932",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysWarningDefault | sysWarningDefault}
   */
  yellow600: "#FAB800",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysWarningHover | sysWarningHover}
   */
  yellow700: "#D69E00",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysWarningPressed | sysWarningPressed}
   */
  yellow800: "#9E7400",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  yellow900: "#423100",

  // Navies

  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy50: "#E2E4F3",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy100: "#BDC2E5",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBrandNavyComplimentary | sysBrandNavyComplimentary}
   */
  navy200: "#8C94D1",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy300: "#707BC7",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy400: "#5B66BE",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy500: "#4753B3",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy600: "#464E8B",
  /**
   * @deprecated Prefer using semantic colours instead
   *
   * Used by {@link lightTheme.colors.sysBrandNavyDefault | sysBrandNavyDefault}
   */
  navy700: "#313A7E",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy800: "#272E63",
  /**
   * @deprecated Prefer using semantic colours instead
   */
  navy900: "#1A1F42",
} as const;

const brandColors = {
  // Uppercase to match the canonical token source; the value is unchanged.
  hubspotOrange: "#FF7A59",
  salesforceBlue: "#00A1E0",
  dynamicsBlue: "#0078D4",
  zohoBlue: "#006EB9",
};

export const lightTheme = {
  colors: {
    // NOTE: Try not to use the primitive colours unless necessary, use the semantic colours instead
    ...primitiveColours,
    ...brandColors,

    // Semantic colours come from the canonical token source (design-tokens/ at
    // the repo root). Change values there, then regenerate with
    // `yarn --cwd design-tokens generate`.
    ...semanticColours,

    // Default workflow stages, moved here from lib/themes/colors.ts so every
    // colour the app uses has one definition. The generated set carries these
    // under sysWorkflowStage* names; these older names stay until the call
    // sites are repointed, since lib/themes/colors.ts still re-exports them.
    toEngageIconColor: "#00DFDF",
    toEngageBackgroundColor: "#E5FCFC",
    nurturingIconColor: "#9E01FF",
    nurturingBackgroundColor: "#8B5CF6",
    meetingBookedIconColor: "#FFCA09",
    meetingBookedBackgroundColor: "#F5E6FF",
    bidCreatedIconColor: "#0070E0",
    bidCreatedBackgroundColor: "#D9ECFF",
    disqualifiedIconColor: "#67798B",
    disqualifiedBackgroundColor: "#EEEFF1",
    wonIconColor: "#2BAB55",
    wonBackgroundColor: "#D5EEDD",
    lostIconColor: "#FF0059",
    lostBackgroundColor: "#FFE5E5",

    // The only alpha value in the token set. Also from colors.ts; grouped with
    // the shadow/overlay question rather than given a semantic name yet.
    opacityDark2: "rgba(23, 31, 44, 0.02)",
  },
  font: {
    fontSize1100: "60px",
    fontSize1000: "50px",
    fontSize900: "42px",
    fontSize800: "35px",
    fontSize700: "29px",
    fontSize600: "24px",
    fontSize500: "20px",
    fontSize400: "17px",
    fontSize300: "14px",
    fontSize200: "12px",
    fontSize100: "10px",
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    fontFamily: "InterVariable, sans-serif",
    fontFamilyMonospace: "monospace",
  },
  // General spacing/layout size scale (design-system scale)
  size: {
    size4: "4px",
    size8: "8px",
    size12: "12px",
    size16: "16px",
    size20: "20px",
    size24: "24px",
    size32: "32px",
    size40: "40px",
    size48: "48px",
    size56: "56px",
    size64: "64px",
    size80: "80px",
    size96: "96px",
    size120: "120px",
    size152: "152px",
    size192: "192px",
  },
  // Layout-tier media queries for object syntax: [theme.breakpoints.laptopUp]: { ... }
  breakpoints: mq,
  /**
   * @deprecated Prefer using fontFamily under font instead
   */
  fontFamily: "InterVariable, sans-serif",
} as const;
